import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { logger } from '@azure/storage-blob';

import { UserApi } from '@/api';
import { SidebarItems1 } from '@/layouts/data';
import { useUserStore } from '@/store';

const extractLinks = (items: typeof SidebarItems1): string[] => {
  return items.reduce((acc, item) => {
    if (item.link) acc.push(item.link);
    if (item.items) acc.push(...extractLinks(item.items));
    return acc;
  }, [] as string[]);
};

export function useRefetchUserOnNavigation() {
  const location = useLocation();
  const { updateUserStore } = useUserStore();
  const links = extractLinks(SidebarItems1);
  const allRoutes = [...links];

  useEffect(() => {
    if (!allRoutes.includes(location.pathname)) return;

    const fetchData = async () => {
      try {
        const [userRes, accountRes] = await Promise.all([
          UserApi.getCurrentUser(),
          UserApi.getMyAccount(),
        ]);

        updateUserStore({
          user: userRes.data,
          account: accountRes.data,
        });
      } catch (err) {
        logger.error('Error fetching user/account info on path change:', err);
      }
    };

    fetchData();
  }, [location.pathname]);
}
